import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

export const AuthenticatedGuard: CanMatchFn = async (
  route: Route,
  segments: UrlSegment[]
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.user()) {
    return true;
  }

  const isAuthenticated = await firstValueFrom(authService.checkStatus());

  if (isAuthenticated) {
    return true;
  }

  // El access pudo caducar con la pestaña abierta (checkStatus no reintenta
  // por sí solo): un intento de refresh antes de expulsar al login
  const renewed = await firstValueFrom(authService.refreshToken());

  if (renewed) {
    return true;
  }

  // Se conserva la ruta para volver tras el login y no perder el contexto
  const returnUrl = '/' + segments.map((s) => s.path).join('/');
  router.navigate(['/auth/login'], { queryParams: { returnUrl } });
  return false;
};
